import { useLazyQuery } from "@apollo/client";
import { TierIiReportVerifier } from "generated-graphql/graphql";
import { BULK_VERIFY_VALIDATION_QUERY } from "queries/tierIIVerification";
import { useCallback } from "react";

export function useBulkVerifyInputValidation() {
  const [query] = useLazyQuery(BULK_VERIFY_VALIDATION_QUERY, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (reportIds: string[], input: TierIiReportVerifier) => {
      const { data } = await query({
        variables: {
          reportIds,
          data: input,
        },
      });

      return data?.bulkTierIIReportVerifierValidator ?? [];
    },
    [query]
  );
}
